import { csx } from "utils/utils";
import logo from "assets/images/logo-white.png";
import { useMemo } from "react";
import { Link, useLocation } from "react-router-dom";

const noop = () => {};

const NotificationItemSystem = ({ notification, onPreviewClick = noop }) => {
  const { pathname } = useLocation();

  const messageClasses = csx([
    "text-mutedGray text-base",
    notification.message.length > 80 ? "truncate" : "break-words",
  ]);

  const title = useMemo(() => {
    if (notification.category !== "system") return notification.title;
    return notification.type === "push"
      ? notification.title
      : notification.type === "banner"
      ? "New Banner Update!"
      : "New System Notification!";
  }, [notification]);

  const message = useMemo(() => {
    const type = notification.type === "push" ? "popout" : "banner";

    if (type === "banner") return;
    return notification.message;
  }, [notification]);

  const handlePreview = () => {
    if (pathname === "/") return window.location.reload();

    onPreviewClick();
  };

  return (
    <div className="flex flex-col w-full my-4">
      <div className="flex items-center">
        <div className="bg-secondary w-6 h-6 flex items-center justify-center rounded-full">
          <img
            className="w-4 h-4 object-center"
            src={logo}
            alt="ConversionCow Logo Notification"
          />
        </div>
        <span className="uppercase ml-2 text-sm">ConversionCow</span>
        <span className="mx-1">&bull;</span>
        <span className="text-sm uppercase">{notification.relative_time}</span>
      </div>

      <div>
        <h3 className="text-base font-medium mt-2 mb-px">{title}</h3>
        <p title={message} className={messageClasses}>
          {message}

          {/* Banner Button */}
          {notification.type === "banner" && (
            <Link
              onClick={handlePreview}
              className="text-secondary font-medium"
              to={"/"}
            >
              Click here to preview
            </Link>
          )}
        </p>
      </div>
    </div>
  );
};

export default NotificationItemSystem;
